import { createGlobalStyle } from "styled-components";

import themesFile from "utils/themes.json";

import { antdStyles } from "styles/antd";
import { customStyles } from "styles/custom";
import { utilistiesCss } from "styles/utilities";

// Styles that are applied globaly in the website
export const GlobalStyle = createGlobalStyle`
  ${customStyles}
  ${antdStyles}
  ${utilistiesCss}
`;

// Theme typing that needs to comply with
export interface Theme {
  label: string; // label of the name (lowercase, for id purposes)
  name: string; // Display name of the theme (showed on theme selections)
  primaryColor: string; // Used in navbar and some backgrounds of contents
  secondaryColor: string; // Used in datastores menu and other different backgrounds and some texts
  highlight: string; // Used on indicators and borders
  textInLight: string; // Used in texts where the background is light
  textInDark: string; // Used in texts where the background is dark
  textDimmedOne: string; // Used in texts with low importance
  emptyBackground: string; // Used on empty spaces
  color3: string; // Green
  color4: string; // Yellow
  color5: string; // red
}

// This allows styled-components to receive the theme vars
export interface ThemeProp {
  theme: Theme;
  percentage?: number;
}

interface Themes {
  [key: string]: Theme;
}

// General colors of the theme
export const colors = {
  green: "#00A783",
  green2: "#5EC662",
  fadedGreen: "#cce6cc",
  red: "#DE002C",
  red2: "#E7AEAE",
  fadedRed: "#ffcccc",
  yellow: "#FFB703",
  yellow2: "#E5D88E",
  fadedYellow: "#E5D88E",
  lightGray: "#E5E4E2",
  gray: "#B2BEB5",
  gray2: "#D8DFD8",
  darkGray: "#808080",
  blueSky: "#3b82f6",
  darkBlue: "#1e293b",
};

// Media queries that specify the px of each breakpoint
export const mediaQueries = {
  mobile: "@media only screen and (min-width: 480px)",
  tablet: "@media only screen and (min-width: 768px)",
  desktop: "@media only screen and (min-width: 1024px)",
  bigDesktop: "@media only screen and (min-width: 1200px)",
};

export const themes: Themes = themesFile;

// Themes typing for typescript uses
export type ColorsType = keyof typeof colors;
export type ThemesType = keyof typeof themes;
